var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotificationsEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1520.98 580.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-26,.cls-41{fill:none;}.cls-2{fill:#fc0;}.cls-3{fill:#f36;}.cls-4{fill:#6c6cff;}.cls-5{fill:url(#Sfumatura_senza_nome_66);}.cls-6{fill:url(#linear-gradient);}.cls-7{fill:url(#Sfumatura_senza_nome_66-2);}.cls-8{clip-path:url(#clip-path);}.cls-9{fill:#00cc6f;}.cls-10{clip-path:url(#clip-path-2);}.cls-11{fill:#fff;}.cls-12,.cls-29{fill:#0f1048;}.cls-12{opacity:0.2;}.cls-13{fill:url(#linear-gradient-2);}.cls-14{fill:#fc906a;}.cls-15{fill:url(#linear-gradient-3);}.cls-16{fill:url(#linear-gradient-4);}.cls-17{fill:url(#linear-gradient-5);}.cls-18{fill:url(#linear-gradient-6);}.cls-19{fill:#fdbc9d;}.cls-20{fill:url(#Sfumatura_senza_nome_58);}.cls-21{fill:url(#Sfumatura_senza_nome_57);}.cls-22{fill:url(#Sfumatura_senza_nome_57-2);}.cls-23{fill:url(#Sfumatura_senza_nome_58-2);}.cls-24,.cls-25{fill:#d86964;}.cls-25{opacity:0.55;}.cls-26{stroke:#fc0;stroke-linecap:round;stroke-miterlimit:10;stroke-width:15.73px;}.cls-27{clip-path:url(#clip-path-3);}.cls-28{fill:#c2e7ff;}.cls-30{fill:url(#Sfumatura_senza_nome_16);}.cls-31{fill:url(#radial-gradient);}.cls-32,.cls-39{fill:#b7445a;}.cls-33{fill:url(#radial-gradient-2);}.cls-34{fill:url(#Sfumatura_senza_nome_7);}.cls-35{fill:#d76377;}.cls-36{fill:#e593a0;}.cls-37{fill:url(#radial-gradient-3);}.cls-38{fill:url(#radial-gradient-4);}.cls-39{opacity:0.5;}.cls-40{fill:url(#Sfumatura_senza_nome_23);}.cls-41{stroke:#c2e7ff;stroke-linejoin:round;stroke-width:3.79px;}.cls-42{fill:url(#Sfumatura_senza_nome_30);}.cls-43{fill:url(#linear-gradient-7);}.cls-44{fill:url(#linear-gradient-8);}.cls-45{fill:url(#linear-gradient-9);}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Sfumatura_senza_nome_66",
    cx: 593.59,
    cy: 214.42,
    r: 184.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#85d490"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#00cc67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#6866fa"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 549.22,
    y1: -182.11,
    x2: 316.43,
    y2: -45.8,
    gradientTransform: "matrix(1, -0.01, -0.01, 0.86, 63.19, 288.44)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fc906a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f57957"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Sfumatura_senza_nome_66-2",
    cx: 594.62,
    cy: 322.57,
    r: 438.59,
    gradientTransform: "translate(0 -103.28) scale(1 1.05)",
    xlinkHref: "#Sfumatura_senza_nome_66"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(50.51 -4.32)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.67,336.58c50.41,125.83,141,207.91,202.43,183.31S757,393.14,696,228.14C626.22,39.32,114,39.62,52.56,64.21S-17.73,210.75,32.67,336.58Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(50.51 -4.32)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M350.92,166.1a9,9,0,0,1,4.56,1.32C340.16,138.21,318.39,120,294.24,120A48.28,48.28,0,0,0,283,121.3c-18.85,4.52-63-12.16-93.61-6.88C168.92,118,108.06,131.3,88.84,123.5c-9.59-3.89-28.69-7.52-39.1-8-15.42-.68-31.73,2.94-49.88,4.23C-48,123.14,28.56,450.63,63.74,445.82c13.63-1.86,25.71-3.64,35-3.64a80.82,80.82,0,0,0,36.6-8.93c14.85-7.48,32.15-9.21,47.83-3.61,7,2.51,14.32,6.83,21.81,6.83,11.86,0,23.25-4.32,33.81-10.41A62.16,62.16,0,0,1,277,418.25a64.32,64.32,0,0,1,6.71,1.12,48.27,48.27,0,0,0,10.53,1.17c21.07,0,40.33-13.89,55.08-36.83-15.44-3.08-27.7-50.58-27.7-108.72C321.62,214.85,334.74,166.1,350.92,166.1Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -583.71,
    y1: -94.7,
    x2: -493.57,
    y2: -192.45,
    gradientTransform: "matrix(0.9, 0.44, -0.44, 1.04, 1107.25, 528.52)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 616.08,
    y1: 201.26,
    x2: 695.85,
    y2: 178.61,
    gradientTransform: "translate(96.27 -5.44) rotate(0.51)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 692.05,
    y1: 321.5,
    x2: 811.06,
    y2: 321.5,
    gradientTransform: "translate(-4.86 -48.06) rotate(-2.39)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 679.23,
    y1: 372.48,
    x2: 800.67,
    y2: 372.48,
    gradientTransform: "translate(-4.86 -48.06) rotate(-2.39)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 695.35,
    y1: 410.54,
    x2: 733.58,
    y2: 366.85,
    gradientTransform: "translate(-4.86 -48.06) rotate(-2.39)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Sfumatura_senza_nome_58",
    cx: 702.38,
    cy: 342.35,
    r: 46.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#fc906a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#f57957"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Sfumatura_senza_nome_57",
    cx: 712.08,
    cy: 198.49,
    r: 121.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fc906a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#f57957"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Sfumatura_senza_nome_57-2",
    cx: 705.63,
    cy: 255.1,
    r: 97.92,
    xlinkHref: "#Sfumatura_senza_nome_57"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Sfumatura_senza_nome_58-2",
    cx: 679.81,
    cy: 309.72,
    r: 91.65,
    xlinkHref: "#Sfumatura_senza_nome_58"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3",
    transform: "translate(50.51 -4.32)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1397,348.58c-50.41,125.83-141,207.91-202.43,183.31S589,254.14,666,82.14c75.14-167.83,649.69-30.52,711.08-5.93S1447.39,222.75,1397,348.58Z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Sfumatura_senza_nome_16",
    cx: 756.49,
    cy: 35.03,
    r: 559.06,
    gradientTransform: "matrix(0.96, 0.29, -0.26, 0.84, 374.77, -81.41)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#d76377"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#b7445a"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 300.52,
    cy: 47.61,
    r: 192.26,
    gradientTransform: "matrix(1.13, 0.22, -0.18, 0.98, 431.72, 41.91)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#b7445a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#d35f74"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 451.24,
    cy: 175.7,
    r: 174.63,
    gradientTransform: "translate(372.73 -9.84) rotate(8.21)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Sfumatura_senza_nome_7",
    cx: 558.9,
    cy: 101.39,
    r: 189.33,
    gradientTransform: "matrix(-0.82, -0.58, 0.1, -0.14, 1337.52, 603.06)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#b7445a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#d35f74"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 840.77,
    cy: 164.34,
    r: 117.29,
    gradientTransform: "matrix(0.99, 0.13, -0.13, 0.99, 128.42, -80.93)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 777.63,
    cy: 308.43,
    r: 73.42,
    gradientTransform: "matrix(1, 0.1, -0.1, 1, -6.04, -150.3)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_23",
    x1: -1726.39,
    y1: -58.9,
    x2: -1775.14,
    y2: -182.88,
    gradientTransform: "matrix(0.99, -0.08, -0.1, -0.8, 2785.58, 84.91)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6c6cff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_30",
    x1: -1903.56,
    y1: 361.38,
    x2: -1871.46,
    y2: 361.38,
    gradientTransform: "matrix(-0.96, -0.27, -0.27, 0.96, -622.38, -608.69)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6c6cff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f1048"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 1257.18,
    y1: 274.39,
    x2: 928.92,
    y2: -252.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0f1048"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#6c6cff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1433.48,
    y1: 362.9,
    x2: 1273.11,
    y2: 298.98,
    gradientTransform: "translate(1089.93 -1002.63) rotate(68.17)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00cc6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00cc6f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -9.7,
    y1: 352.63,
    x2: 361.91,
    y2: 213.27,
    gradientTransform: "translate(120.03 -32.33) rotate(21.83)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fc0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#fc0",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1",
    "data-name": 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 143.83,
    cy: 292.05,
    rx: 119.74,
    ry: 245.44,
    transform: "translate(-47.78 70.11) rotate(-21.83)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 292.42,
    cy: 560.08,
    r: 20.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 306.59,
    y: -1.55,
    width: 33.14,
    height: 73.25,
    rx: 16.57,
    transform: "translate(577.38 284.06) rotate(-135)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 384.96,
    cy: 511.46,
    r: 36.57
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 489.18,
    cy: 271.53,
    rx: 40.72,
    ry: 101.79
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "196.32 364.81 562.55 346.13 549.4 189.28 171.38 161.37 196.32 364.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M406.67,271.34C406.67,214.11,419,174,439.8,174L120.87,147.2,148.1,393l291.7-15.11C419,377.89,406.67,328.57,406.67,271.34Z",
    transform: "translate(50.51 -4.32)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M350.92,166.1a9,9,0,0,1,4.56,1.32C340.16,138.21,318.39,120,294.24,120A48.28,48.28,0,0,0,283,121.3c-18.85,4.52-63-12.16-93.61-6.88C168.92,118,108.06,131.3,88.84,123.5c-9.59-3.89-28.69-7.52-39.1-8-17.56-.78-36.48,2.31-57.49,5.33C-23.61,123.14,32.3,450.14,68,445.24c11.89-1.64,22.44-3.06,30.75-3.06a80.82,80.82,0,0,0,36.6-8.93c14.85-7.48,32.15-9.21,47.83-3.61,7,2.51,14.32,6.83,21.81,6.83,11.86,0,23.25-4.32,33.81-10.41A62.16,62.16,0,0,1,277,418.25a64.32,64.32,0,0,1,6.71,1.12,48.27,48.27,0,0,0,10.53,1.17c21.07,0,40.33-13.89,55.08-36.83-15.44-3.08-27.7-50.58-27.7-108.72C321.62,214.85,334.74,166.1,350.92,166.1Z",
    transform: "translate(50.51 -4.32)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 249.39,
    cy: 204.65,
    r: 23.09
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 177.39,
    cy: 126.65,
    r: 23.09
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 181.26,
    cy: 305.32,
    r: 23.09
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 92.37,
    cy: 375.36,
    r: 23.09
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 31.9,
    cy: 272,
    r: 23.09
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 109.09,
    cy: 204.56,
    r: 23.09
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 23.09,
    cy: 135.56,
    r: 23.09
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 305.57,
    cy: 375.79,
    r: 23.09
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 204.47,
    cy: 416.13,
    r: 23.09
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 337.73,
    cy: 258.69,
    r: 23.09
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 337.59,
    cy: 126.68,
    r: 23.09
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M339.16,373.51l86.18-9.6s-6.29-8.64-9.83-23.73c0,0-75.83,11.25-84.87,9C330.64,349.16,336.75,369,339.16,373.51Z",
    transform: "translate(50.51 -4.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M323.79,302.2l84.52-5.65s-3.64-26.05-3.13-33.8c0,0-80.56,5.17-84.14,2.07C321,264.82,322.89,295.71,323.79,302.2Z",
    transform: "translate(50.51 -4.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M408.31,219.92l-82.06-6.71s5.68-26.41,7.74-30l85.24,3.51S409.07,212.32,408.31,219.92Z",
    transform: "translate(50.51 -4.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M541.5,208.85c-6.77-13.59-8.12-34.87,5.6-39.6,21.21-7.32,63.7-19.46,75.89-26.17,13.21-7.27,40.78-2,58,2.42a104.57,104.57,0,0,0,24.1,3.14c5.65.1,17.15,1,19.09,8.61,2.38,9.42-.87,13.08-6.15,17.65-2.63,2.27-14.51,5.13-17.89,6-24.35,6-48.7,3.53-55.23,10.26C591.36,246.29,554.68,235.31,541.5,208.85Z",
    transform: "translate(50.51 -4.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M550,169l41.46-9c11.54-3.42,29.42,6.42,39.8,12.52h0c14.14,4.72,23.31,4.21,38.06,2.09l47,1.94-3.94,120.18,0,41.13L676.7,360.8a40.44,40.44,0,0,1-21.7,6.39l-121.92-7.26c-37.28-.23-65.19-22-66.93-59.23l-4.79-102.47C461,189.59,541.46,170.2,550,169Z",
    transform: "translate(50.51 -4.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M681.05,173s74.19-.64,95.5,4.52c15.45,3.74,10.09,20.28,10.19,25.93a15.73,15.73,0,0,1-.76,5,19.1,19.1,0,0,1-20,13c-20.81-1.9-59.34-6-78.5-5.64C662.84,216.33,657.35,175,681.05,173Z",
    transform: "translate(50.51 -4.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M687.23,268.69l73.16-.16c13.67-.1,21-12.66,19.58-27.38-.59-6.33,5.58-20.25-22.29-22.31-17.47-1.29-52.62-2.42-76-.23a20.72,20.72,0,0,0-16,10.32l-1.52,2.63a20.8,20.8,0,0,0,1.95,23.59l4.86,5.93A20.82,20.82,0,0,0,687.23,268.69Z",
    transform: "translate(50.51 -4.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M759.42,266.64A9.33,9.33,0,0,1,769,274.7c1.57,11.78,2.77,32.27-7.25,35.67-36.7,12.44-102.35,13.75-102.35,13.75-8.81.79-5-10.36-8.66-18.44h0A20.73,20.73,0,0,1,658,280l8.71-7.6a13.08,13.08,0,0,1,8.09-3.22Z",
    transform: "translate(50.51 -4.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M668.82,317.47l80,1.28s13.93,2.93,14.9,15.07-7,17.55-17.76,21.27c-8.37,2.89-57.35,8.9-79,11.45a23.14,23.14,0,0,1-18-5.57h0a23.14,23.14,0,0,1,1.8-36.22l4.14-3A23.16,23.16,0,0,1,668.82,317.47Z",
    transform: "translate(50.51 -4.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M703.67,148.91a14.41,14.41,0,0,0,8.77,3.94c5.74.59,10.51,1.55,10.51,1.55S719.43,147.59,703.67,148.91Z",
    transform: "translate(50.51 -4.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M668.7,317.74l80,1.28s13.94,2.92,14.91,15.06-7,17.56-17.76,21.28c-8.38,2.88-57.36,8.89-79,11.45a23.13,23.13,0,0,1-18-5.58h0A23.13,23.13,0,0,1,650.73,325l4.15-3A23.12,23.12,0,0,1,668.7,317.74Z",
    transform: "translate(50.51 -4.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M680.87,172.8s74.19-.64,95.5,4.52c15.45,3.74,10.1,20.28,10.2,25.93a15.46,15.46,0,0,1-.77,5,19.1,19.1,0,0,1-20,13c-20.8-1.9-59.34-6-78.5-5.63C662.67,216.09,657.17,174.8,680.87,172.8Z",
    transform: "translate(50.51 -4.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M687.29,268.42l73.15-.16c13.67-.09,20.95-12.65,19.58-27.37-.58-6.33,5.58-20.25-22.29-22.31-17.47-1.29-52.61-2.42-76-.23a20.75,20.75,0,0,0-16,10.31l-1.51,2.63a20.8,20.8,0,0,0,1.94,23.6l4.86,5.93A20.81,20.81,0,0,0,687.29,268.42Z",
    transform: "translate(50.51 -4.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M759.86,266.63a9.32,9.32,0,0,1,9.54,8.07c1.58,11.77,2.78,32.26-7.25,35.66-36.7,12.44-102.34,13.75-102.34,13.75-8.82.79-5-10.35-8.67-18.43h0a20.74,20.74,0,0,1,7.3-25.65l8.72-7.61a13.11,13.11,0,0,1,8.09-3.22Z",
    transform: "translate(50.51 -4.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M707.19,175.17c6.33,4.93,18.5,18.54,1.17,41.94,0,0,9.68,6.34,9.68,23.84s-12.66,28.3-10.43,27.56,14.53,27.56-3,45.43c0,0,13,36.5-15.65,49.16,0,0-13.24,3.72-34,4.09s-115.34-4.83-113.48-6.32c1.25-1-29-51.93-49.06-85.36a55.42,55.42,0,0,1,.14-57.25h0a85.14,85.14,0,0,1,73.28-41c30.55.18,65.59.23,72.47-.38,10.8-.95,51-3.08,62.54-3.68A9.42,9.42,0,0,1,707.19,175.17Z",
    transform: "translate(50.51 -4.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M664.41,174.91c-26.8,3.18-32.36,1.05-33.28-3.59Z",
    transform: "translate(50.51 -4.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M708.3,216.38l45.27,2S723.34,222.86,708.3,216.38Z",
    transform: "translate(50.51 -4.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M723.31,268.23l36.59-1.12S733.4,272.34,723.31,268.23Z",
    transform: "translate(50.51 -4.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M755.41,174.91s19.67.12,25.57,4,6.21,8.25,6.7,13.65l-.74,8.45S768.5,195.39,755.41,174.91Z",
    transform: "translate(50.51 -4.32)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 1285.83,
    cy: 304.05,
    rx: 245.44,
    ry: 119.74,
    transform: "translate(575.94 1380.29) rotate(-68.17)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 1412.33,
    cy: 496.56,
    r: 24.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1233.33,
    y: 45.58,
    width: 42.88,
    height: 57.77,
    rx: 21.44,
    transform: "translate(365.37 904.75) rotate(-45)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-26",
    x1: 722.74,
    y1: 72.07,
    x2: 674.37,
    y2: 18.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-26",
    x1: 712.43,
    y1: 104.68,
    x2: 659.03,
    y2: 100.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-26",
    x1: 759.53,
    y1: 67.69,
    x2: 750.94,
    y2: 8.52
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M1026.1,217.71c-14.16,51.13-15.3,96.09-2,99.79s36.11-35.28,50.28-86.41,15.49-96.2,2.15-99.9S1040.27,166.58,1026.1,217.71Z",
    transform: "translate(50.51 -4.32)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-29",
    cx: 1084.57,
    cy: 239.05,
    rx: 113.06,
    ry: 29.32,
    transform: "translate(615.15 1216.1) rotate(-74.51)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "1401.14 394.33 1001.67 271.19 1061.76 118.33 1457.53 214.97 1401.14 394.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M1090.46,141.94l-74.72-18.87c-15.45-3.11-30-17.53-42.76-26.83L924.41,64.11,837.18,74.78l-43.81,61.38-2.13,68.3c-5.21,10.72-11.7,4.31-15.68,13a16,16,0,0,0,4.91,19.24l15.24,11.83s8.31,8.08,35.42,18.18c8.08,3,38.45,8.56,73.86,14.41,11.19,1.84,59.6-2.53,71,.55,50.6,13.68,68.21,18.33,68.21,18.33Z",
    transform: "translate(50.51 -4.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M845.68,257.57s8.25-60.38,4.45-124.53C850.11,132.73,838.35,247.75,845.68,257.57Z",
    transform: "translate(50.51 -4.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M989.67,128.09a54.86,54.86,0,0,0-24.16-38.61l-62-41L848.42,27.15a13,13,0,0,0-13.53-.52C831.94,28.34,828,41.14,837,53.14c8.53,11.37,19,15,20.45,17.33l31.2,38.71,21.15,45.68c1.63,2.4,18.06,22.51,22.79,28.65,25.35,32.93,60.29-2.79,61.69-20.24Z",
    transform: "translate(50.51 -4.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M867.71,85.4c2.3-6.33,14.87-12.83,14.87-12.83S870.3,74.3,863.86,83.1h0l3.85,2.3",
    transform: "translate(50.51 -4.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M798.19,200.35a9.12,9.12,0,0,1-12.58,7c-16.18-6.88-47.52-20.1-44.15-39.21,2.94-16.69,1.28-36.86,21-32.39,16.18,3.65,28.17,5.33,36.41,7.62a9.1,9.1,0,0,1,6.56,10.17Z",
    transform: "translate(50.51 -4.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M829.28,209.23c-1.92-5.74-1.43-16.4-1.41-16.86l1,0c0,.11-.5,10.93,1.36,16.49Z",
    transform: "translate(50.51 -4.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M919.33,176.29a2,2,0,0,1-3.65,1.68c-5.79-11.5-23.19-47-25.95-63.61,0,0,15.53,41.86,25.28,54.94A37.41,37.41,0,0,1,919.33,176.29Z",
    transform: "translate(50.51 -4.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M758.62,92c14,3.52,42.81,6.46,60.1,9,19.91,2.88,51.62,12.18,61.37,15.11a11.47,11.47,0,0,1,5.85,4,19.19,19.19,0,0,1,3.4,17.56c-3.76,12.57-12.42,14.87-19.4,14.21s-69.37-11.34-86.74-10.78-32.34.18-39.08-11.57C740.16,122.59,741.48,87.66,758.62,92Z",
    transform: "translate(50.51 -4.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M871.18,120.26A43.48,43.48,0,0,1,885.4,124a7.66,7.66,0,0,1,4.21,5.18,17.37,17.37,0,0,1-1.9,12.68,6.6,6.6,0,0,1-.47.87,10.69,10.69,0,0,1-13.59,3.91l-8.53-4a11.76,11.76,0,0,1-6.58-12.88c0-.13.06-.26.08-.39A11.68,11.68,0,0,1,871.18,120.26Z",
    transform: "translate(50.51 -4.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M743.78,151.28c1.47-5.51,5.91-8.85,11.43-10.32,17.08-4.55,50.51,2.19,72,5.56C855.73,151,879.4,152,880.93,168c.91,9.47-4.26,24-25.72,23.84s-80.94-6.68-80.94-6.68S736.77,177.52,743.78,151.28Z",
    transform: "translate(50.51 -4.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M791.5,200l-.67-.74c.07-.07,6.84-6.27,7.18-11l1,.07C798.64,193.49,791.79,199.76,791.5,200Z",
    transform: "translate(50.51 -4.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M871,186c-2.82.17-9.31-1.58-14.39-4.36a11.23,11.23,0,0,1-5.43-12.53l1.6-6.57a3.84,3.84,0,0,1,4.48-2.86c5.73,1.16,16.52,3.61,19.24,6.19C880.22,169.4,875.7,185.69,871,186Z",
    transform: "translate(50.51 -4.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M867.35,152.53A814.52,814.52,0,0,0,773,140.41s38.56.88,51.61,3.1S867.35,152.53,867.35,152.53Z",
    transform: "translate(50.51 -4.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M808.92,53.85c32.38,10.4,68.82,19.37,75.28,28.38s2.68,26-14.21,28.18S823.92,99.75,801,99c-18.93-.66-30.13-6-36.54-7.84a6.55,6.55,0,0,1-3.38-2.27S758,60.14,771,53.14C777.62,49.59,788,47.14,808.92,53.85Z",
    transform: "translate(50.51 -4.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M882.55,83c-2.92-1.31-8.37-3.67-13.69-5.59a11.18,11.18,0,0,0-14.74,8,3,3,0,0,0-.07.32,11.18,11.18,0,0,0,6.67,12.58c6.74,2.81,16.09,6.67,17.93,7.09,2.72.63,12.08-8.84,7.56-18.79A7.16,7.16,0,0,0,882.55,83Z",
    transform: "translate(50.51 -4.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M870.18,113.07c-43.94-13-104.95-19.65-104.95-19.65l-4.12-4.58s54,7.78,100.37,18.77a16,16,0,0,1,8.7,5.46Z",
    transform: "translate(50.51 -4.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M774.68,214.28c1.07-4.75,4.88-8.15,9.16-8.32,11.68-.45,37.16-1.1,53.24.91,21.41,2.68,36.1,3.55,40.37,16.11s-3.05,20.61-19.12,21.34-60.63-2.44-60.63-2.44S769.58,236.92,774.68,214.28Z",
    transform: "translate(50.51 -4.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M871.64,219.18c-.12,0-2-.73-4.45-1.36-4.46-1.13-11-2.08-13.51,1.15-3.9,5-6.17,14.58,5.34,16.05s14.75,2.09,16.67-1.93S875.68,220.81,871.64,219.18Z",
    transform: "translate(50.51 -4.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M887,97.88c3-10.83-3.87-17.4-3.87-17.4-17-10.26-30.26-13.1-30.26-13.1L864.3,69.3s12.49,3.43,21,9.55S887,97.88,887,97.88Z",
    transform: "translate(50.51 -4.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M840.78,25.26l7.63,4.11,16.79,4.51S849.76,22.92,840.78,25.26Z",
    transform: "translate(50.51 -4.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M822.81,190.29s8.56-2,10.21-20.15c1.58-17.18-5.85-23.62-5.85-23.62S836,135.14,836,125.14s-2.63-23.49-2.63-23.49a40,40,0,0,0,9.89-19c1.43-7.35-2.5-20.18-2.5-20.18S887,72.17,888,85.66s-5.41,21.19-5.41,21.19l-12.4,6.22s18.16-5.5,20,19.29-11.53,73.13-11.53,73.13l3.93,44.32H833.26l-6.91-6.22s7.7-4.45,7.69-19.79c0-14.66-11-19.66-11-19.66Z",
    transform: "translate(50.51 -4.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1077,131.47l76.77,18.26-50.07,196.54-78.74-28.71s25.5-2.14,52.68-150.64C1080,154.08,1081.11,142.35,1077,131.47Z",
    transform: "translate(50.51 -4.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 1058.98,
    y: 280.85,
    width: 17.88,
    height: 31.03,
    rx: 8.94,
    transform: "translate(1929.04 1047.82) rotate(-152.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1063.53,
    y: 277.37,
    width: 19.28,
    height: 19.28,
    rx: 9.64,
    transform: "translate(16.15 196.34) rotate(-10.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M1022.32,315c13.37,3.71,30-35.46,44.16-86.73,13.28-47.92,16.74-87.53,6-95.91",
    transform: "translate(50.51 -4.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M1054.45,348.29c19.36,5.36,46.29-46.89,61.14-100.5s18.65-112.27-.71-117.63l-1,3.72c13.14,3.64,15.48,49.87-2,112.88s-43.25,101.44-56.38,97.8Z",
    transform: "translate(50.51 -4.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M1470.47,221.9,1116.8,130.67s12.3,3.87,8.5,56.2c-1.42,19.65-3.55,45.12-15.44,75.21-34.86,88.25-52.28,86.76-52.28,86.76l336.68,93.31S1468.28,368.64,1470.47,221.9Z",
    transform: "translate(50.51 -4.32)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-44",
    cx: 1285.83,
    cy: 304.05,
    rx: 245.44,
    ry: 119.74,
    transform: "translate(575.94 1380.29) rotate(-68.17)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-45",
    cx: 143.83,
    cy: 295.05,
    rx: 119.74,
    ry: 245.44,
    transform: "translate(-48.9 70.32) rotate(-21.83)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsEmpty);
export default __webpack_public_path__ + "static/media/notifications-empty.88db413dc1fd3ad0785687e8a4902c70.svg";
export { ForwardRef as ReactComponent };